import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-billing',
    templateUrl: './billing.component.svg',
    styleUrls: ['./billing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingComponent {}
